export const FileTypeKey = {
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO',
    PDF: 'PDF',
    UNSUPPORTED: 'UNSUPPORTED',
};
